import {useEffect} from 'react'

const THRESHOLD = 280       // Phải kéo đủ 280px mới trigger refresh
const MAX_PULL = 200        // Giới hạn UI dịch chuyển tối đa
const SHOW_SPINNER_AT = 200 // Spinner chỉ xuất hiện sau 200px
const SCROLL_SELECTOR = '.app-scroll-container'

export function usePullToRefresh() {
    useEffect(() => {
        if (!window?.cordova) return

        let startY = 0
        let currentY = 0
        let ptrActive = false
        let tracking = false
        let spinner = null
        let wasAtTopOnStart = false

        const getScrollEl = () => document.querySelector(SCROLL_SELECTOR)
        const isModalOpen = () => document.querySelector('.SideModal') !== null
        const isAtTop = () => {
            return document.documentElement.scrollTop <= 0
        }
        const createSpinner = () => {
            if (spinner) return
            spinner = document.createElement('div')
            spinner.style.cssText = `
        position: fixed;
        top: 0; left: 0; right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 0;
        overflow: hidden;
        z-index: 9999;
        pointer-events: none;
    `
            spinner.innerHTML = `
        <style>
            @keyframes ptr-ring-rotate {
                0%   { stroke: #d1392a; stroke-dashoffset: 0; }
                25%  { stroke: #efb301; }
                50%  { stroke: #6f9e33; stroke-dashoffset: -60; }
                75%  { stroke: #2facc4; }
                100% { stroke: #d1392a; stroke-dashoffset: -120; }
            }
        </style>
        <div style="position:relative;display:flex;align-items:center;justify-content:center;width:52px;height:52px;opacity:0;transition:opacity 0.15s" class="ptr-wrapper">
            <!-- Vòng tròn loading -->
            <svg width="52" height="52" viewBox="0 0 52 52"
                style="position:absolute;top:0;left:0;transform-origin:center"
                class="ptr-ring-svg">
                <circle
                    cx="26" cy="26" r="22"
                    fill="none"
                    stroke="#d1392a"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-dasharray="120"
                    stroke-dashoffset="0"
                    style="transform-origin:center;transform:rotate(-90deg)"
                    class="ptr-ring"
                />
            </svg>
            <!-- Logo Kristo -->
            <svg width="32" height="32" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"
                style="transform-origin:center;position:relative">
                <path d="m59.24 68.75c-3.84 4.35-42.56 4.32-46.45 0-3.9-4.32 15.3-26.02 23.05-26.02 7.74 0 27.24 21.67 23.4 26.02z" fill="#d1392a"/>
                <path d="m3.25 12.77c4.35-3.85 26.02 15.64 26.02 23.39 0 7.77-21.7 26.97-26.02 23.05-4.32-3.9-4.35-42.6 0-46.45z" fill="#2facc4"/>
                <path d="m68.75 12.77c4.35 3.84 4.32 42.55 0 46.45-4.32 3.89-26.02-15.31-26.02-23.05 0-7.75 21.67-27.25 26.02-23.4z" fill="#6f9e33"/>
                <path d="m59.24 3.25c3.84 4.35-15.65 26.02-23.4 26.02-7.77 0-26.97-21.7-23.05-26.02 3.9-4.32 42.61-4.35 46.45 0z" fill="#efb301"/>
                <path d="m37.38 58.55h-2.76q-0.16 0-0.3-0.06-0.14-0.06-0.26-0.17-0.11-0.11-0.16-0.26-0.07-0.14-0.07-0.3v-43.52q0-0.16 0.07-0.31 0.05-0.14 0.16-0.25 0.12-0.11 0.26-0.17 0.14-0.06 0.3-0.06h2.76q0.16 0 0.3 0.06 0.15 0.06 0.26 0.17 0.11 0.11 0.17 0.25 0.06 0.15 0.06 0.31v43.52q0 0.16-0.06 0.3-0.06 0.15-0.17 0.26-0.11 0.11-0.26 0.17-0.14 0.06-0.3 0.06z" fill="#ffffff"/>
                <path d="m58.55 34.62v2.76q0 0.16-0.06 0.3-0.06 0.15-0.17 0.26-0.11 0.11-0.26 0.17-0.14 0.06-0.3 0.06h-43.52q-0.16 0-0.31-0.06-0.14-0.06-0.25-0.17-0.11-0.11-0.17-0.26-0.06-0.14-0.06-0.3v-2.76q0-0.16 0.06-0.3 0.06-0.14 0.17-0.25 0.11-0.12 0.25-0.17 0.15-0.07 0.31-0.07h43.52q0.16 0 0.3 0.07 0.15 0.05 0.26 0.17 0.11 0.11 0.17 0.25 0.06 0.14 0.06 0.3z" fill="#ffffff"/>
            </svg>
        </div>
    `
            document.body.appendChild(spinner)
        }

        const removeSpinner = () => {
            if (spinner) {
                spinner.remove()
                spinner = null
            }
        }

        const applyPull = (deltaY) => {
            const el = document.documentElement
            const pull = Math.min(Math.sqrt(deltaY) * 10, MAX_PULL)
            const spinnerProgress = Math.max(0, Math.min(
                (deltaY - SHOW_SPINNER_AT) / (THRESHOLD - SHOW_SPINNER_AT),
                1
            ))

            document.querySelector(SCROLL_SELECTOR).style.transition = 'none'
            document.querySelector(SCROLL_SELECTOR).style.transform = `translateY(${pull}px)`

            if (deltaY >= SHOW_SPINNER_AT) {
                if (!spinner) createSpinner()

                const wrapper = spinner.querySelector('.ptr-wrapper')
                const logoSvg = spinner.querySelector('.ptr-wrapper > svg:last-child')
                const ring = spinner.querySelector('.ptr-ring')
                const ringSvg = spinner.querySelector('.ptr-ring-svg')

                spinner.style.height = `${pull}px`

                if (wrapper) wrapper.style.opacity = spinnerProgress

                if (logoSvg) {
                    // Logo xoay theo progress khi kéo
                    logoSvg.style.transform = `rotate(${spinnerProgress * 360}deg)`
                }

                if (ring) {
                    // Ring dashoffset: 120 (ẩn hoàn toàn) → 0 (hiện full) theo progress
                    ring.style.strokeDashoffset = 120 - (spinnerProgress * 120)
                }

                if (ringSvg) {
                    // Ring SVG xoay ngược chiều logo một chút cho đẹp
                    ringSvg.style.transform = `rotate(${spinnerProgress * -180}deg)`
                }

            } else {
                if (spinner) {
                    const wrapper = spinner.querySelector('.ptr-wrapper')
                    if (wrapper) wrapper.style.opacity = 0
                }
            }
        }

        const resetPull = (triggerReload = false) => {
            const scrollEl = document.querySelector(SCROLL_SELECTOR)
            if (scrollEl) {
                scrollEl.style.transition = 'transform 0.3s ease'
                scrollEl.style.transform = 'translateY(0)'
            }

            if (triggerReload) {
                // Khi đã đủ ngưỡng: ring quay animation liên tục cho đến khi reload
                if (spinner) {
                    const ring = spinner.querySelector('.ptr-ring')
                    const ringSvg = spinner.querySelector('.ptr-ring-svg')
                    const logoSvg = spinner.querySelector('.ptr-wrapper > svg:last-child')
                    if (ring) ring.style.animation = 'ptr-ring-rotate 1s linear infinite'
                    if (ringSvg) ringSvg.style.animation = 'ptr-ring-rotate 1s linear infinite'
                    if (logoSvg) logoSvg.style.animation = 'ptr-ring-rotate 1s linear infinite'
                }
                setTimeout(() => window.location.reload(), 300)
            } else {
                removeSpinner()
            }
        }

        const onTouchStart = (e) => {
            const el = getScrollEl()
            console.log('[PTR] touchstart', {
                scrollTop: el?.scrollTop,
                wasAtTop: el ? el.scrollTop <= 0 : 'no element',
                elFound: !!el,
            })

            if (isModalOpen()) return
            tracking = true
            ptrActive = false
            startY = e.touches[0].clientY
            currentY = startY
            wasAtTopOnStart = isAtTop()
        }

        const onTouchMove = (e) => {
            if (!tracking) return
            if (!wasAtTopOnStart) return

            currentY = e.touches[0].clientY
            const deltaY = currentY - startY

            if (!ptrActive) {
                if (deltaY <= 10) return
                ptrActive = true
            }

            if (deltaY <= 0) {
                ptrActive = false
                resetPull(false)
                return
            }

            applyPull(deltaY)
        }

        const onTouchEnd = () => {
            tracking = false
            wasAtTopOnStart = false
            if (!ptrActive) return
            ptrActive = false

            const deltaY = currentY - startY
            if (deltaY >= THRESHOLD) {
                resetPull(true)
            } else {
                resetPull(false)
                removeSpinner()
            }
        }

        document.addEventListener('touchstart', onTouchStart, {passive: true})
        document.addEventListener('touchmove', onTouchMove, {passive: true})
        document.addEventListener('touchend', onTouchEnd, {passive: true})

        return () => {
            document.removeEventListener('touchstart', onTouchStart)
            document.removeEventListener('touchmove', onTouchMove)
            document.removeEventListener('touchend', onTouchEnd)
            removeSpinner()
            const el = getScrollEl()
            if (el) el.style.transform = ''
        }
    }, [])
}